import { render, staticRenderFns } from "./FFooter.vue?vue&type=template&id=b92f619c&scoped=true&"
import script from "./FFooter.vue?vue&type=script&lang=js&"
export * from "./FFooter.vue?vue&type=script&lang=js&"
import style0 from "./FFooter.vue?vue&type=style&index=0&id=b92f619c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92f619c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/souzaramon/repos/personal/fluid/pwa-fluid/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VFooter,VSpacer})
